import * as React from "react";
export class TimeStamp extends React.Component {
    render() {
        let cls = "rj-superbanner__event-timestamp";
        let dataUаt = `superbanner-event-timestamp-${this.props.modifier}`;
        return (React.createElement("span", { className: `${cls} ${cls}--${this.props.modifier}`, "data-uat": dataUаt }, this.props.text));
    }
}
//# sourceMappingURL=TimeStamp.js.map